import React from "react";
import Filter from "../Filter/Filter";

import { FilterItemsWrapper } from "./FilterItems.styles";

const FilterItems = () => {
  return (
    <FilterItemsWrapper>
      <Filter />
    </FilterItemsWrapper>
  );
};

export default FilterItems;
